export const isOpenInTelegram = () => {
  if (typeof window === 'undefined') return false;

  const tg = (window as any)?.Telegram?.WebApp || (window as any)?.TelegramWebviewProxy;
  return !!tg;
};

export const telegramAppIsOpenFromMobile = () => {
  if (typeof window === 'undefined') return false;

  const ua = window.navigator.userAgent?.toLowerCase() || '';

  // Telegram mobile app detection
  if (/telegram\/\d+/.test(ua)) return true;

  // Detect mobile devices
  if (/iphone|ipad|ipod|android|mobile/.test(ua)) return true;

  return false;
};

export const telegramAppIsOpenFromDesktop = () => {
  if (typeof window === 'undefined') return false;

  const ua = window.navigator.userAgent?.toLowerCase() || '';

  // Telegram desktop app detection
  if (ua.includes('telegramdesktop')) return true;

  // Detect desktop OS only if no mobile indicators are present
  if (/mac os|macintosh|windows|linux/.test(ua) && !/iphone|ipad|ipod|android|mobile/.test(ua)) {
    return true;
  }

  return false;
};
